import { call, put } from 'redux-saga/effects'

import history from '../../../history'
import {
  CompanyDetailInterface,
  CreateCompanyInputInterface
} from '../../../interfaces/company'
import { handleUnAuthorizedError } from '../../../utils/saga.util'
import { createCompanySucceed, requestFailure } from '../actions'

export function* createCompanySaga(
  companyApi: {
    createCompany: (...args: any[]) => any
  },
  {
    payload: companyDetail
  }: {
    payload: CreateCompanyInputInterface
  }
) {
  try {
    const { data }: { data: CompanyDetailInterface } = yield call(
      companyApi.createCompany,
      companyDetail
    )
    yield put(createCompanySucceed(data))
    yield call(history.push, `/company/${data.companyId}/edit`)
  } catch (e) {
    yield handleUnAuthorizedError(e)
    yield put(requestFailure(e))
  }
}
